/**
 * eon-home.js — THE EON WEAR / Home
 * Conversión de prototypes/home/script.js. Controla el drawer de
 * navegación móvil integrado en el hero. Reentrante: se puede volver a
 * inicializar de forma segura cuando Theme Editor recarga la sección
 * (shopify:section:load) sin duplicar listeners, porque cada recarga
 * sustituye por completo los nodos del DOM anteriores.
 */
(function () {
  "use strict";

  var desktopQuery = window.matchMedia("(min-width: 1024px)");
  var current = null;

  function initEonNav(root) {
    root = root || document;

    var openBtn = root.querySelector("#eon-menu-open");
    var closeBtn = root.querySelector("#eon-menu-close");
    var nav = root.querySelector("#eon-mobile-nav");
    var scrim = root.querySelector("#eon-menu-scrim");

    if (!openBtn || !closeBtn || !nav || !scrim) return;
    if (openBtn.dataset.eonBound === "true") return;

    var body = document.body;
    var lastFocused = null;

    function onKeydown(event) {
      if (event.key === "Escape") {
        closeMenu();
        return;
      }
      if (event.key === "Tab") trapFocus(event);
    }

    function trapFocus(event) {
      var focusable = nav.querySelectorAll("a[href], button:not([disabled])");
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openMenu() {
      lastFocused = document.activeElement;
      body.classList.add("eon-nav-open");
      nav.classList.add("is-open");
      nav.setAttribute("aria-hidden", "false");
      openBtn.setAttribute("aria-expanded", "true");
      closeBtn.focus();
      document.addEventListener("keydown", onKeydown);
    }

    function closeMenu() {
      body.classList.remove("eon-nav-open");
      nav.classList.remove("is-open");
      nav.setAttribute("aria-hidden", "true");
      openBtn.setAttribute("aria-expanded", "false");
      document.removeEventListener("keydown", onKeydown);
      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
    }

    openBtn.addEventListener("click", openMenu);
    closeBtn.addEventListener("click", closeMenu);
    scrim.addEventListener("click", closeMenu);

    nav.querySelectorAll(".eon-mobile-nav__link").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });

    function handleViewportChange(event) {
      if (event.matches && body.classList.contains("eon-nav-open")) closeMenu();
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener("change", handleViewportChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(handleViewportChange);
    }

    openBtn.dataset.eonBound = "true";

    current = {
      openBtn: openBtn,
      closeMenu: closeMenu,
      handleViewportChange: handleViewportChange,
    };
  }

  function teardownEonNav() {
    if (!current) return;
    if (desktopQuery.removeEventListener) {
      desktopQuery.removeEventListener("change", current.handleViewportChange);
    } else if (desktopQuery.removeListener) {
      desktopQuery.removeListener(current.handleViewportChange);
    }
    document.body.classList.remove("eon-nav-open");
    current = null;
  }

  /**
   * Icono de carrito del header del home — abre el mismo <cart-drawer> de
   * Dawn que ya usa el add-to-cart de la PDP. Un único drawer, sin duplicar
   * infraestructura.
   */
  function initEonCartIconLink(root) {
    var link = root.querySelector("#eon-site-cart-link");
    var cartDrawer = document.querySelector("cart-drawer");
    if (!link || !cartDrawer || link.dataset.eonBound === "true") return;
    link.dataset.eonBound = "true";

    link.setAttribute("aria-haspopup", "dialog");
    link.addEventListener("click", function (event) {
      event.preventDefault();
      cartDrawer.open(link);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initEonNav(document);
      initEonCartIconLink(document);
    });
  } else {
    initEonNav(document);
    initEonCartIconLink(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    if (section.querySelector("#eon-mobile-nav")) {
      teardownEonNav();
      initEonNav(section);
    }
    if (section.querySelector("#eon-site-cart-link")) {
      initEonCartIconLink(section);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    if (!section.querySelector("#eon-mobile-nav")) return;
    teardownEonNav();
  });
})();
